import React, {useEffect, useState} from 'react';
import './TypePrintSadanShop.scss';
import numericFunction from "../../../utils/NumericFunction";
import {formatToPersianAddCommaNegativeToParentheses} from "../../../utils/CommaSeparator";

const NoteBookReportPrint = (props) => {

  const format = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  const [componentData, setComponentData] = useState({})
  useEffect(() => {
    const temp = {...props.data.data.data.data}
    // temp.part_1.data = [...temp.part_1.data, ...temp.part_1.data, ...temp.part_1.data, ...temp.part_1.data, ...temp.part_1.data, ...temp.part_1.data, ...temp.part_1.data]
    setComponentData(temp)
  }, [props.data])

  try {
    debugger
    return (
      <div className="main-print-factor">

        <table className="solid-print-table">

          <thead className="header-page-print">
          <tr>
            <th style={{borderLeft: '1px solid white', borderRight: '1px solid white', borderTop: '1px solid white'}}
                colSpan={8}></th>
          </tr>
          <tr>
            <th style={{borderBottom: '1px solid white'}} colSpan={8}>
              <div className="shop-name">
                <div className="name-side">
                  <h3>{componentData?.shopName}</h3>
                </div>
              </div>
            </th>
          </tr>

          <tr>
            <th style={{borderBottom: '1px solid white', borderLeft: '1px solid white'}} colSpan={3}>
              <div className="inline-text">
                <p>از تاریخ :</p>
                <p>{numericFunction.e2p(componentData?.startDate)}</p>
              </div>
            </th>
            <th style={{borderBottom: '1px solid white', borderLeft: '1px solid white'}} colSpan={2}>
              <div className="inline-text" style={{display:'flex' , justifyContent:'center'}}>
                <p>از سند :</p>
                <p>{numericFunction.e2p(componentData?.firstId)}</p>
              </div>
            </th>
            <th style={{borderBottom: '1px solid white'}} colSpan={3}>
              <div className="inline-text">
                <p>تـاریـخ :</p>
                <p>{new Date().toLocaleDateString("fa-ir", format)}</p>
              </div>
            </th>
          </tr>

          <tr>
            <th colSpan={3} style={{borderLeft: '1px solid white'}}>
              <div className="inline-text">
                <p>تا تاریخ :</p>
                <p>{numericFunction.e2p(componentData?.endDate)}</p>
              </div>
            </th>
            <th colSpan={2} style={{borderLeft: '1px solid white'}}>
              <div className="inline-text" style={{display:'flex' , justifyContent:'center'}}>
                <p>تا سند :</p>
                <p>{numericFunction.e2p(componentData?.lastId)}</p>
              </div>
            </th>
            <th colSpan={3}>
              <div className="inline-text" style={{columnGap: '4px'}}>
                {/*<p>شماره صفحه :</p>*/}
                {/*<p>{numericFunction.e2p(index + 1)}</p>*/}
                {/*<p>از</p>*/}
                {/*<p>{numericFunction.e2p(makeData.length)}</p>*/}
              </div>
            </th>
          </tr>

          <tr>
            <th style={{borderLeft: '1px solid white', borderRight: '1px solid white'}} colSpan={8}></th>
          </tr>

          </thead>
          {componentData.data.length > 0 && componentData.data.map((v) => {
              let TBed = 0
              let TBedRemaining = 0
              let TBes = 0
              let TBesRemaining = 0
              return <>
                <tr>
                  <th className="gray-box border-gray-box" colSpan={8}>{numericFunction.e2p(v?.accountsData)}</th>
                </tr>
                <tr>
                  <th style={{borderLeft: '1px solid white'}} className="column-font" colSpan={2}></th>
                  <th className="column-font" colSpan={2}></th>
                  <th className="column-font" colSpan={2}>گردش طی دوره</th>
                  <th className="column-font" colSpan={2}>گردش طی دوره</th>
                </tr>
                <tr>
                  <th className="column-font">شماره سند</th>
                  <th className="column-font">شماره عطف</th>
                  <th className="column-font">تاریخ</th>
                  <th className="column-font">شرح</th>
                  <th className="column-font">گردش بدهکار</th>
                  <th className="column-font">گردش بستانکار</th>
                  <th className="column-font">مانده بدهکار</th>
                  <th className="column-font">مانده بستانکار</th>
                </tr>

                {v.data.map((q) => {
                    const documentId = q?.documentId
                    const documentNumber = q?.documentNumber
                    const date = q?.date
                    const description = q?.description
                    const bed = q?.bed
                    const bes = q?.bes
                    const bedRemaining = q?.bedRemaining
                    const besRemaining = q?.besRemaining
                    TBed += +q.bed
                    TBedRemaining += +q.bedRemaining
                    TBes += +q.bes
                    TBesRemaining += +q.besRemaining

                    return <tr>
                      <th>{numericFunction.e2p(documentId)}</th>
                      <th>{numericFunction.e2p(documentNumber)}</th>
                      <th>{numericFunction.e2p(date)}</th>
                      <th>{numericFunction.e2p(description)}</th>
                      <th>{formatToPersianAddCommaNegativeToParentheses(bed)}</th>
                      <th>{formatToPersianAddCommaNegativeToParentheses(bes)}</th>
                      <th>{formatToPersianAddCommaNegativeToParentheses(bedRemaining)}</th>
                      <th>{formatToPersianAddCommaNegativeToParentheses(besRemaining)}</th>
                    </tr>
                  }
                )}

                <tr>
                  <th style={{textAlign: 'center', borderRight: '0.25px solid #000'}} className="gray-box">جمع</th>
                  <th className="gray-box"></th>
                  <th className="gray-box"></th>
                  <th className="gray-box"></th>
                  <th style={{textAlign: 'center'}}
                      className="gray-box">{formatToPersianAddCommaNegativeToParentheses(TBed)}</th>
                  <th style={{textAlign: 'center'}}
                      className="gray-box">{formatToPersianAddCommaNegativeToParentheses(TBes)}</th>
                  <th style={{textAlign: 'center'}}
                      className="gray-box">{formatToPersianAddCommaNegativeToParentheses(TBedRemaining)}</th>
                  <th style={{textAlign: 'center', borderLeft: '0.25px solid #000'}}
                      className="gray-box">{formatToPersianAddCommaNegativeToParentheses(TBesRemaining)}</th>
                </tr>

              </>
            }
          )}
          <tfoot className="empty-header-footer">
          <tr>
            <th colSpan={8}></th>
          </tr>
          </tfoot>
        </table>

      </div>
    );
  } catch (error) {
    return <>{error.toLocaleString()}</>
  }
};

export default NoteBookReportPrint;